<script lang="ts">
  import Modal from '../ui/Modal.svelte';
  import Kbd from '../ui/Kbd.svelte';
  import { shell } from './shell.svelte';
  import { t } from '../i18n.svelte';
  const mod = typeof navigator !== 'undefined' && navigator.platform?.includes('Mac') ? '⌘' : 'Ctrl';
  const rows = $derived([
    [[mod, 'K'], t('shortcuts.palette')],
    [['N'], t('shortcuts.new_entry')],
    [['S'], t('shortcuts.timer_toggle')],
    [['G', 'D'], t('shortcuts.goto_dashboard')],
    [['G', 'T'], t('shortcuts.goto_timer')],
    [['G', 'R'], t('shortcuts.goto_entries')],
    [['G', 'K'], t('shortcuts.goto_clients')],
    [['G', 'A'], t('shortcuts.goto_reports')],
    [['G', 'I'], t('shortcuts.goto_settings')],
    [['?'], t('shortcuts.help')]
  ] as Array<[string[], string]>);
</script>

<Modal bind:open={shell.shortcutsOpen} title={t('shortcuts.title')} size="sm">
  <ul>
    {#each rows as [keys, label] (label)}
      <li><span>{label}</span><span class="keys">{#each keys as k (k)}<Kbd size="md">{k}</Kbd>{/each}</span></li>
    {/each}
  </ul>
</Modal>

<style>
  ul { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
  li { display: flex; justify-content: space-between; align-items: center; padding: var(--space-2) 0; border-bottom: 1px solid var(--border); font-size: var(--text-md); }
  li:last-child { border-bottom: 0; }
  .keys { display: flex; gap: var(--space-1); }
</style>
